<div class="action" [ngClass]="fileWrapper?.action" (click)="performActionClick()"></div>
<div class="icon" [ngClass]="type"></div>
<div class="file-name" [class.rejected]="isRejected">
    @if (isRejected) {
        <mat-icon color="error"> warning </mat-icon>
    }
    @if (fileWrapper?.showCheckMark) {
        <mat-icon color="accent"> check_circle </mat-icon>
    }
    {{ fileWrapper?.file?.file?.name | slice: 0 : 30 }}
</div>
@if (progress) {
    <mat-progress-bar color="accent" [value]="progress"> </mat-progress-bar>
}
